import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

/** 3rd Party */
import { MsalService } from '@azure/msal-angular';

/** Services */
import { AlertService } from './core/services/alert.service';
import { I18nService } from './core/services/i18n.service';

/** Models */
import { Alert } from 'src/app/shared/interfaces/alert.model';

/** Constants */
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth.service';
import { SuccessDialogComponent } from './shared/components/dialogs/success-dialog/success-dialog.component';
import { ErrorDialogComponent } from './shared/components/dialogs/error-dialog/error-dialog.component';

import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { AuthenticationService } from './shared/services/authentication.service';
import { ProfileService } from './components/profile/profile.service';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TourMatMenuModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'web-app';
  isToggled = false;
  profile: any;

  constructor(
    private alertService: AlertService,
    private i18nService: I18nService,
    public snackBar: MatSnackBar,
    public router: Router,
    private authService: AuthService,
    private authenticationService: ProfileService,
    private keycloakService: KeycloakService
  ) {
    this.keycloakService.keycloakEvents$.subscribe({
      next(event) {
        if (event.type == KeycloakEventType.OnTokenExpired) {
          keycloakService.updateToken(20);
        }
      },
    });

 
  }

  ngOnInit(): void {
    this.initI18n();
    this.subscribeToAlerts();
    if (this.authService.isLoggedIn()) {
      this.profile = this.authService.getUserDetails();
    }
  }

  private initI18n(): void {
    this.i18nService.init(
      environment.languageConfig.defaultLanguage,
      environment.languageConfig.supportedLanguages
    );
  }

  private subscribeToAlerts(): void {
    this.alertService.alertEvent.subscribe((alert: Alert) => {
      if (alert.type == 'Success') {
        this.snackBar.openFromComponent(SuccessDialogComponent, {
          duration: 5000,
          panelClass: ['success-snackbar-container'],
          data: {
            message: alert.message,
          },
        });
      } else {
        this.snackBar.openFromComponent(ErrorDialogComponent, {
          duration: 5000,
          panelClass: ['error-snackbar-container'],
          data: {
            message: alert.message,
          },
        });
      }
    });
  }
}
